import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { loadWebhookEventSubscriptions } from '../actions/load-webhook-event-subscriptions';
import {
  webhookEventSubscriptionsForOrgId,
  webhookEventSubscriptionsStateForOrgId,
} from '../webhook-event-subscription-selectors';

import { UiButton } from '../../ui/ui-button';
import { WebhookEventSubscriptionDialog } from '../webhook-event-subscription-dialog';
import { WebhookEventTestButton } from '../webhook-event-test-button';

import { teGenericDescription } from './utils/te-generic-utils';
import { WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE } from '../utils/webhook-event-subscription-utils';

type InputProps = {
  org: Org;
};

export const ConnectGenericIntegration = (props: InputProps) => {
  const { org } = props;

  const dispatch = useDispatch();
  const webhookSubscriptions = useSelector((state: any) =>
    webhookEventSubscriptionsForOrgId(state, org.org_id),
  );
  useSelector((state: any) => webhookEventSubscriptionsStateForOrgId(state, org.org_id));

  useEffect(() => {
    dispatch(loadWebhookEventSubscriptions(org.org_id));
  });

  const [isEditing, setIsEditing] = useState<boolean>(false);
  const existingSubscription =
    webhookSubscriptions?.find(
      (sub) =>
        sub.subscriberType === WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE.TEAM_ENGINE_GENERIC,
    ) || null;

  const handleToggleIsEditing = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div>
      <div className="typo-subtitle u-maxWidth-750px u-margin-bottom-lg">
        {teGenericDescription}
      </div>
      <div className="u-display-flex u-justifyContent-spaceBetween">
        <UiButton size="sm" onClick={handleToggleIsEditing}>
          {existingSubscription ? 'Manage Webhook Connection' : 'Connect To Webhook'}
        </UiButton>
        <WebhookEventTestButton webhookEventSubscription={existingSubscription} />
      </div>
      {isEditing ? (
        <WebhookEventSubscriptionDialog
          org={org}
          subscriberType={WEBHOOK_EVENT_SUBSCRIPTION_SUBSCRIBER_TYPE.TEAM_ENGINE_GENERIC}
          existingSubscription={existingSubscription}
          onClose={handleToggleIsEditing}
        />
      ) : null}
    </div>
  );
};
